import { render, staticRenderFns } from "./AnLink.vue?vue&type=template&id=2439d93a&scoped=true&"
import script from "./AnLink.vue?vue&type=script&lang=ts&"
export * from "./AnLink.vue?vue&type=script&lang=ts&"
import style0 from "./AnLink.vue?vue&type=style&index=0&id=2439d93a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2439d93a",
  null
  
)

export default component.exports